import notice from "@/assets/images/myapp/notice.png";
import menuSelect from "@/assets/images/home/menuSelect.png";
export default function () {
    const baseUrl = "https://apaas-static.oss-cn-beijing.aliyuncs.com";
    return {
        nodata: `${baseUrl}/nodata.png`,
        system: {
            logo: {
                default: `${baseUrl}/logo-cloud.png`,
                cscec: `${baseUrl}/logo-cscec.png`
            },
            logoGreen: `${baseUrl}/logo_green.png`,
            boy: `${baseUrl}/boy.png`
        },
        login: {
            loginBg: {
                default: `${baseUrl}/login/loginBg-apaas.jpg`,
                cscec: `${baseUrl}/login/loginBg-cscec.jpg`
            },
            wechat: `${baseUrl}/login/wechat.png`
        },
        home: {
            menuBg: `${baseUrl}/comp/menuBg.png`,
            menuSelect,
            appStore: `${baseUrl}/comp/appStore.png`,
            dataStore: `${baseUrl}/comp/dataStore.png`
        },
        myapp: {
            notice
        },
        company: {
            adminTag: `${baseUrl}/comp/admintag.png`
        },
        app: {
            addapp: `${baseUrl}/comp/addapp.png`,
            uploadapp: `${baseUrl}/comp/uploadapp.png`,
            modelapp: `${baseUrl}/comp/modelapp.png`
        },
        AppStore: {
            mask: `${baseUrl}/store/mask.png?x-oss-process=image/resize,mfit,h_240`,
            appLogo: `${baseUrl}/store/appLogo.png`
        },
        dataCenter: {
            mask: `${baseUrl}/dataCenter/dataCenter.png?x-oss-process=image/resize,mfit,h_240`,
            database: `${baseUrl}/dataCenter/database.png?x-oss-process=image/resize,m_fixed,w_70,h_70`
        },
        introduction: {
            mp4: `${baseUrl}/introduce.mp4`,
            loginModalImage: `${baseUrl}/introduction/loginleft.png`,
            erweimaMingshu: `${baseUrl}/introduction/mingshu.jpeg`,
            erweimaXinjijian: `${baseUrl}/introduction/xinjijian.jpg`,

            bg: `${baseUrl}/introduction/bg.png`,
            web: `${baseUrl}/introduction/web.png`,
            apaas: {
                linebg: `${baseUrl}/introduction/linebg.png`,
                building: `${baseUrl}/introduction/building.png`,
                play: `${baseUrl}/introduction/playbtn.png`,
                net: `${baseUrl}/introduction/net.png`,
                suo: `${baseUrl}/introduction/suo.png`,

                fagaiwei: `${baseUrl}/introduction/partner/fagaiwei.png`,
                caizhengbu: `${baseUrl}/introduction/partner/caizhengbu.png`,
                zhujianbu: `${baseUrl}/introduction/partner/zhujianbu.png`,
                caizhengshehui: `${baseUrl}/introduction/partner/caizhengshehui.png`,
                hbfagaiwei: `${baseUrl}/introduction/partner/hbfagaiwei.png`,
                xjfagaiwei: `${baseUrl}/introduction/partner/xjfagaiwei.png`,
                bjjiaotongwei: `${baseUrl}/introduction/partner/bjjiaotongwei.png`,
                scjiaotongting: `${baseUrl}/introduction/partner/scjiaotongting.png`,
                gzjiaotongting: `${baseUrl}/introduction/partner/gzjiaotongting.png`,
                gsjiaotongting: `${baseUrl}/introduction/partner/gsjiaotongting.png`,
                zhongjian: `${baseUrl}/introduction/partner/zhongjian.png`,
                zhongjiao: `${baseUrl}/introduction/partner/zhongjiao.png`,
                zhongtie: `${baseUrl}/introduction/partner/zhongtie.png`,
                zhongtiejian: `${baseUrl}/introduction/partner/zhongtiejian.png`,
                zhonghua: `${baseUrl}/introduction/partner/zhonghua.png`,
                pinganjinrong: `${baseUrl}/introduction/partner/pinganjinrong.png`,
                jianhang: `${baseUrl}/introduction/partner/jianhang.png`,
                gonghang: `${baseUrl}/introduction/partner/gonghang.png`,
                pingan: `${baseUrl}/introduction/partner/pingan.png`,
                nongfa: `${baseUrl}/introduction/partner/nongfa.png`,
                worldbank: `${baseUrl}/introduction/partner/worldbank.png`,
                aiib: `${baseUrl}/introduction/partner/aiib.png`,
                aifc: `${baseUrl}/introduction/partner/aifc.png`,
                beida: `${baseUrl}/introduction/partner/beida.png`,
                qinghua: `${baseUrl}/introduction/partner/qinghua.png`,
                beikong: `${baseUrl}/introduction/partner/beikong.png`,
                shouchuang: `${baseUrl}/introduction/partner/shouchuang.png`,
                jiashi: `${baseUrl}/introduction/partner/jiashi.png`,
                zhonglian: `${baseUrl}/introduction/partner/zhonglian.png`,
                zhaoshang: `${baseUrl}/introduction/partner/zhaoshang.png`,
                huatai: `${baseUrl}/introduction/partner/huatai.png`,

                form: `${baseUrl}/introduction/form.png`,
                flow: `${baseUrl}/introduction/flow.png`,
                customShow: `${baseUrl}/introduction/customShow.png`,
                resource: `${baseUrl}/introduction/resource.png`,
                knowledge: `${baseUrl}/introduction/knowledge.png`,
                customPage: `${baseUrl}/introduction/customPage.png`,
                authority: `${baseUrl}/introduction/authority.png`,
                api: `${baseUrl}/introduction/api.png`
            },
            firm: {
                main: `${baseUrl}/introduction/main_firm.png`,

                shujv: `${baseUrl}/introduction/shujv.png`,
                ziliao: `${baseUrl}/introduction/ziliao.png`,
                guankong: `${baseUrl}/introduction/guankong.png`,
                zhibiao: `${baseUrl}/introduction/zhibiao.png`,
                fengxian: `${baseUrl}/introduction/fengxian.png`,
                juece: `${baseUrl}/introduction/juece.png`,

                zhouqi: `${baseUrl}/introduction/zhouqi.png`,
                xiaolv: `${baseUrl}/introduction/xiaolv.png`,
                baogao: `${baseUrl}/introduction/baogao.png`,
                shuju: `${baseUrl}/introduction/shuju.png`,
                yujing: `${baseUrl}/introduction/yujing.png`,
                touzi: `${baseUrl}/introduction/touzi.png`,

                firm_1: `${baseUrl}/introduction/firm_1.png`,
                firm_2: `${baseUrl}/introduction/firm_2.png`,
                firm_3: `${baseUrl}/introduction/firm_3.png`,
                firm_4: `${baseUrl}/introduction/firm_4.png`,
                firm_5: `${baseUrl}/introduction/firm_5.png`,
                firm_6: `${baseUrl}/introduction/firm_6.png`,
                firm_koubei1: `${baseUrl}/introduction/firm_koubei1.png`,
                firm_koubei2: `${baseUrl}/introduction/firm_koubei2.png`,
                firm_koubei3: `${baseUrl}/introduction/firm_koubei3.png`

            },
            gov: {
                main: `${baseUrl}/introduction/main_gov.png`,

                zhangkong: `${baseUrl}/introduction/zhangkong.png`,
                nanluoshi: `${baseUrl}/introduction/nanluoshi.png`,
                xiangmuduo: `${baseUrl}/introduction/xiangmuduo.png`,

                zhouqi_gov: `${baseUrl}/introduction/zhouqi_gov.png`,
                jinzhan_gov: `${baseUrl}/introduction/jinzhan_gov.png`,
                baogao_gov: `${baseUrl}/introduction/baogao_gov.png`,
                shuju_gov: `${baseUrl}/introduction/shuju_gov.png`,
                yujing_gov: `${baseUrl}/introduction/yujing_gov.png`,
                xiaolv_gov: `${baseUrl}/introduction/xiaolv_gov.png`,

                gov_1: `${baseUrl}/introduction/gov_1.png`,
                gov_2: `${baseUrl}/introduction/gov_2.png`,
                gov_3: `${baseUrl}/introduction/gov_3.png`,
                gov_4: `${baseUrl}/introduction/gov_4.png`,
                gov_5: `${baseUrl}/introduction/gov_5.png`,
                gov_6: `${baseUrl}/introduction/gov_6.png`,
                gov_koubei1: `${baseUrl}/introduction/gov_koubei1.png`,
                gov_koubei2: `${baseUrl}/introduction/gov_koubei2.png`,
                gov_koubei3: `${baseUrl}/introduction/gov_koubei3.png`,
                gov_koubei4: `${baseUrl}/introduction/gov_koubei4.png`
            },
            partner: {
                main: `${baseUrl}/introduction/main_partner.png`,
                huoban: `${baseUrl}/introduction/huoban.png`,
                zhuanjia: `${baseUrl}/introduction/zhuanjia.png`,
                kaifashang: `${baseUrl}/introduction/kaifashang.png`,
                hezuo: `${baseUrl}/introduction/hezuo.png`,
                gongxiang: `${baseUrl}/introduction/gongxiang.png`,
                shouyi: `${baseUrl}/introduction/shouyi.png`,
                peixun: `${baseUrl}/introduction/peixun.png`,
                next: `${baseUrl}/introduction/next.png`,
                erweima: `${baseUrl}/introduction/erweima.png`
            }
        }
    };
}



// WEBPACK FOOTER //
// ./src/data/system/imageSrcMap.js